import React from 'react';
import { useController, ApplicationView } from '@aha-app/mvc';
import type AssistantViewController from '../AssistantView/AssistantViewController';
import styles from './SuggestionsPanel.module.css';
import classnames from 'classnames';
import draftSvg from '../../assets/icons/draft.svg';
import listSvg from '../../assets/icons/list.svg';
import refineSvg from '../../assets/icons/refine.svg';
import summarizeSvg from '../../assets/icons/summarize.svg';
import whiteboardSvg from '../../assets/icons/whiteboard.svg';

const iconFile = name => {
  switch (name) {
    case 'draft':
      return draftSvg;
    case 'list':
      return listSvg;
    case 'refine':
      return refineSvg;
    case 'summarize':
      return summarizeSvg;
    case 'whiteboard':
      return whiteboardSvg;
  }
};

const SuggestionsPanel: React.FC<{
  className?: string;
}> = ({ className }) => {
  const controller = useController<AssistantViewController>();
  const { agentName, readOnly } = controller.state;

  // eslint-disable-next-line no-unused-expressions
  agentName; // Unused but triggers re-renders if the agent changes, but the agent can't be in state.

  const agent = controller.agent;
  let suggestions = agent.getSuggestions();

  suggestions = suggestions.filter(suggestion => suggestion.prefix);

  if (suggestions.length === 0 || readOnly) {
    return null;
  }

  return (
    <div
      className={classnames(
        styles.suggestionList,
        styles.suggestionListBelow,
        className,
        {}
      )}
    >
      <div className={styles.suggestionsContainer}>
        {suggestions.map(({ title, prompt, prefix, icon }) => (
          <React.Fragment key={title}>
            <aha-button
              class={styles.suggestionButton}
              kind='default'
              size='small'
              onClick={() =>
                controller.actionAddSuggestionAsAssistantMessage(prompt, prefix)
              }
            >
              <div className={styles.suggestionButtonInside}>
                <div className={styles.suggestionIcon}>
                  <img src={iconFile(icon)} alt={title} />
                </div>
                <span className={styles.suggestionText}>{title}</span>
              </div>
            </aha-button>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ApplicationView(SuggestionsPanel);
